<template>
	<div class="page-container">
		<head-top :head-title="merchant.retailerName || '详情'" goBack="true"></head-top>

		<div class="merchant-info flex_a">
			<div class="merchant-logo">
				<img v-if="merchant.logo" class="merchant-logo-img" :src="getImageUrl(merchant.logo)" />
			</div>
			<div class="merchant-meta">
				<div class="merchant-name">{{ merchant.retailerName }}</div>
				<div class="merchant-rebate">{{ merchant.memberCommissionValue }}% 返利</div>
				<div class="merchant-desc">{{ merchant.synopsis }}</div>
			</div>
		</div>


		<div class="section-block bg_a" v-if="merchant.richText">
			<div class="section-title">返利说明</div>
			<div class="section-card desc-card" v-html="merchant.richText"></div>
		</div>

		<!-- <div class="section-block bg_a" v-if="merchant.commissionList&&merchant.commissionList.length">
			<div class="section-title">分类返利</div>
			<div class="section-card commission-card">
				<div class="commission-item flex_c" v-for="item in merchant.commissionList" :key="item.id">
					<span class="commission-name">{{ item.name }}</span>
					<span class="commission-rate">{{ item.rate }}</span>
				</div>
			</div>
		</div> -->

		<div class="bottom-bar flex_c">
			<div class="home-entry flex_b" @click="goHome">
				<van-icon name="home-o" class="home-icon" />
				<div class="home-text">首页</div>
			</div>

			<div class="shop-btn" @click="handleGo">去购物，拿返利</div>
		</div>

		<!-- 上报弹窗 -->
		<van-popup v-model="showReport" position="bottom" round :close-on-click-overlay="false" close-on-popstate safe-area-inset-bottom :style="{ height: '80%' }">
			<div class="report-panel bg_a">
				<div class="report-header flex_c">
					<div class="report-title">下单商品预报</div>
					<van-icon name="cross" class="report-close" @click="closeReport" />
				</div>

				<div class="report-list">
					<div v-if="reportRows.length === 0" class="report-empty">
						<van-icon name="point-gift-o" class="empty-icon" />
						<div class="empty-text">请点击添加下单商品，填写将要下单的商品，填写完成后方可跳转到目标网站</div>
					</div>
					 <div v-else class="report-item" v-for="(row, index) in reportRows" :key="index">
						<div class="report-item-link">{{ row.submissionLink }}</div>
						<div class="report-item-remark">备注：{{ row.remark || '-' }}</div>
						<div class="report-item-content flex_c">
							<div class="item-row flex_a">
								<div class="price-value">单价：${{ row.price }}</div>
								<div>数量：{{ row.totalNum }}</div>
							</div>
							
							<div class="item-actions flex_c">
								<van-icon name="edit" class="edit-row" @click="editReportRow(index)" />
								<van-icon name="close" class="delete-row" @click="removeReportRow(index)" />
							</div>
						</div>
					</div>
				</div>

				<div class="report-import-row flex_b">
					<!-- <div class="import-item flex_d" @click="handleImportFromRecord">
						<van-icon name="clock-o" class="import-icon" />
						<div class="import-text">从记录导入(近20条)</div>
					</div> -->
					<div class="import-item flex_d" @click="handleCopyLastOrder">
						<van-icon name="orders-o" class="import-icon" />
						<div class="import-text">复制上一单</div>
					</div>
					<div class="import-item flex_d" @click="handleAddProduct">
						<van-icon name="records-o" class="import-icon" />
						<div class="import-text">手动添加商品</div>
					</div>
				</div>

				<div class="report-confirm" @click="submitReport">确认预报</div>
			</div>
		</van-popup>

		<!-- 添加商品弹窗 -->
		<van-popup v-model="showAddModal" position="center" round :close-on-click-overlay="false" close-on-popstate :style="{ width: '90%' }">
			<div class="add-panel bg_a">
				<div class="add-header flex_c">
					<div class="add-title">{{ editingIndex >= 0 ? '编辑商品' : '添加商品' }}</div>
					<van-icon name="cross" class="add-close" @click="closeAddModal" />
				</div>
				
				<div class="add-body">
					<div class="add-field">
						<div class="add-label">商品链接：</div>
						<textarea class="add-textarea" rows="5" name="submissionLink" v-model="currentProduct.submissionLink" placeholder="请输入要下单商品的链接" maxlength="1000"></textarea>
					</div>
					
					<div class="add-field">
						<div class="add-label">商品单价（单位$）：</div>
						<input class="add-input" v-model="currentProduct.price" name="price" placeholder="请输入商品的单价" />
					</div>
					<div class="add-field">
						<div class="add-label">商品数量：</div>
						<input class="add-input" v-model="currentProduct.totalNum" name="totalNum" type="number" placeholder="请输入要下单的数量" />
					</div>
					<div class="add-field">
						<div class="add-label">备注：</div>
						<textarea class="add-textarea" rows="2" name="remark" v-model="currentProduct.remark" placeholder="选填,如:Nars眼影" maxlength="100"></textarea>
					</div>
				</div>
				
				<div class="add-actions">
					<div class="add-submit" @click="confirmAddProduct">{{ editingIndex >= 0 ? '保存' : '添加' }}</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import {
			getLoginMember,
			getMerchantDetail,
			submitMemberSubmission,
			getMemberShortLink,
			getLastSummaryReport,
			importLast20DetailData,
			imageUrl
		} from '@/apis/api.js'

	export default {
		name: 'Detail',
		components: {
			headTop: headTop
		},
		data() {
			return {
				merchant: {},
				// 是否显示上报弹窗
				showReport: false,
				// 是否显示添加商品弹窗
				showAddModal: false,
				// 当前编辑的商品索引，-1 表示新增
				editingIndex: -1,
				// 上报商品列表
				reportRows: [],
				// 当前正在添加/编辑的商品数据
				currentProduct: {
					submissionLink: '', // 商品链接
					price: '', // 商品价格
					totalNum: '', // 商品数量
					remark: '' // 备注信息
				}
			}
		},

		mounted() {
			const id = this.$route.query.id
			if (id) {
				this.loadData(id)
			}
		},
		// 监听路由参数变化，切换商家时重新加载数据
		watch: {
			'$route.query.id'(newId) {
				if (newId) {
					this.loadData(newId)
				}
			}
		},
		methods: {
			getImageUrl(path) {
				return imageUrl(path)
			},
			loadData(id) {
				this.$toast.loading({
					message: '加载中...',
					duration: 0
				})
				getMerchantDetail(id)
					.then(res => {
						this.merchant = res.merchant || {}
					})
					.catch(e => {
						if (e.handled) return
						this.$toast(e.msg || '加载失败')
					})
					.finally(() => {
						this.$toast.clear()
					})
			},

			handleGo() {
				if (!getLoginMember()) {
					this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
					return
				}
				if (this.merchant.reportCheck === 1) {
					this.showReport = true
					return
				}
				this.$toast.loading({ message: '跳转中...', duration: 0 })
				getMemberShortLink(this.merchant.id)
					.then(res => {
						this.$toast.clear()
						const url = res.msg
						if (url) {
							window.open(url, '_blank')
						} else {
							this.$toast('该商家暂无购物链接')
						}
					})
					.catch(e => {
						this.$toast.clear()
						if (!e.handled) {
							this.$toast('获取购物链接失败')
						}
					})
			},
			
			goHome() {
				this.$router.replace('/')
			},
			
			closeReport() {
				this.showReport = false
				this.reportRows = []
			},
			handleImportFromRecord() {
					this.$toast.loading({ message: '导入中...', duration: 0 })
					importLast20DetailData()
						.then(res => {
							this.$toast.clear()
							const rows = res|| []
							if (rows.length === 0) {
								this.$toast('暂无上报记录')
								return
							}
							this.reportRows = rows.map(item => ({
								key: Date.now() + '-' + Math.random(),
								submissionLink: item.submissionLink || '',
								price: String(item.price || ''),
								totalNum: String(item.totalNum || ''),
								remark: item.remark || ''
							}))
						})
						.catch(e => {
							this.$toast.clear()
							if (!e.handled) {
								this.$toast('导入失败')
							}
						})
				},
				handleCopyLastOrder() {
					this.$toast.loading({ message: '加载中...', duration: 0 })
					getLastSummaryReport()
						.then(res => {
							this.$toast.clear()
							const rows = res|| []
							if (rows.length === 0) {
								this.$toast('暂无上报记录')
								return
							}
							this.reportRows = rows.map(item => ({
								key: Date.now() + '-' + Math.random(),
								submissionLink: item.submissionLink || '',
								price: String(item.price || ''),
								totalNum: String(item.totalNum || ''),
								remark: item.remark || ''
							}))
						})
						.catch(e => {
							this.$toast.clear()
							if (!e.handled) {
								this.$toast('获取上次记录失败')
							}
						})
				},
			
			handleAddProduct() {
					if (this.reportRows.length >= 10) {
						this.$toast('单次上报不能超过10个商品')
						return
					}
					this.editingIndex = -1
				this.currentProduct = {
					submissionLink: '',
					price: '',
					totalNum: '',
					remark: ''
				}
				this.showAddModal = true
			},
			editReportRow(index) {
				this.editingIndex = index
				const row = this.reportRows[index]
				this.currentProduct = {
					submissionLink: row.submissionLink,
					price: row.price,
					totalNum: row.totalNum,
					remark: row.remark || ''
				}
				this.showAddModal = true
			},
			closeAddModal() {
				this.showAddModal = false
				this.editingIndex = -1
			},
			// 确认添加/编辑商品
			confirmAddProduct() {
				const {
					submissionLink,
					price,
					totalNum
				} = this.currentProduct
				if (!submissionLink.trim()) {
					this.$toast('请填写商品链接')
					return
				}
				if (!price.trim()) {
					this.$toast('请填写商品价格')
					return
				}
				if (!String(totalNum).trim()) {
					this.$toast('请填写商品数量')
					return
				}
				const productData = {
					key: Date.now() + '-' + Math.random(),
					submissionLink: submissionLink.trim(),
					price: price.trim(),
					totalNum: Number(totalNum),
					remark: this.currentProduct.remark.trim()
				}
				// 更新或添加商品
				if (this.editingIndex >= 0) {
					this.reportRows[this.editingIndex] = productData
				} else {
					this.reportRows.push(productData)
				}
				this.closeAddModal()
			},
			removeReportRow(index) {
				this.reportRows.splice(index, 1)
			},

			submitReport() {
					if (this.reportRows.length === 0) {
						this.$toast('请先添加下单商品')
						return
					}
					if (this.reportRows.length > 10) {
						this.$toast('单次上报不能超过10个商品，请删除多余商品')
						return
					}
				
				this.$toast.loading({ message: '提交中...', duration: 0 })
				submitMemberSubmission(this.merchant.id, this.reportRows.map(row => ({
						submissionLink: row.submissionLink,
						totalNum: row.totalNum,
						price: row.price,
						remark: row.remark || null
					})))
					.then(res => {
						this.$toast.clear()
						this.showReport = false
						this.reportRows = []
						const url = res.msg
						// 上报成功后弹出确认框，引导跳转购物
						this.$dialog.alert({
								title: '上报成功',
								message: '上报信息已提交，请继续购物拿返利。',
								theme: 'round-button',
							})
							.then(() => {
								if (url) {
									window.open(url, '_blank')
								} else {
									this.$toast('该商家暂无购物链接')
								}
							})
					})
					.catch(e => {
						this.$toast.clear()
						if (e.handled) return
						this.$toast(e.msg || '上报失败')
					})
			},

		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;
		padding-bottom:84px;

		.merchant-info {
			padding: 14px;
			background: #ffffff;

			.merchant-logo {
				flex: none;
				width: 90px;
				height: 90px;
				margin-right: 12px;
				background: #fff;
				border-radius: 4px;
				overflow: hidden;

				.merchant-logo-img {
					width: 100%;
					height: 100%;
					object-fit: contain;
					border-radius: 4px;
					overflow: hidden;
				}
			}

			.merchant-meta {
				flex: 1;

				.merchant-name {
					width: 100%;
					color: #222222;
					font-size: 14px;
					line-height: 1.5;
					word-break: break-all;
				}

				.merchant-rebate {
					width: 100%;
					margin-top: 8px;
					color: #e33737;
					font-size: 12px;
				}

				.merchant-desc {
					width: 100%;
					margin-top: 8px;
					line-height: 1.5;
					color: #999999;
					font-size: 12px;
					word-break: break-all;
				}
			}

		}

		.section-block {
			padding: 0 14px;
			margin-top: 14px;

			.section-title {
				padding: 20px 0;
				border-bottom: 1px solid #e4e7ed;
				color: #222222;
				font-size: 14px;
				font-weight: bold;
			}

			.section-card {
				padding: 20px 0;
			}

			.desc-card {
				padding: 12px 14px;

				:deep(img) {
					max-width: 100%;
					height: auto;
				}

				:deep(table) {
					width: 100%;
					max-width: 100%;
					border-collapse: collapse;
				}

				:deep(ol) {
					list-style-type: decimal;
				}

				:deep(ul) {
					list-style-type: disc;
				}
			}

			.commission-card {
				padding: 0 0 12px;

				.commission-item {
					width: 100%;
					padding: 12px 0;
					border-bottom: 1px solid #e4e7ed;
					font-size: 13px;

					.commission-name {
						flex: 1;
						color: #333333;
						word-break: break-all;
					}

					.commission-rate {
						flex: none;
						width: 60px;
						color: #e33737;
						text-align: right;
					}
				}
			}
		}

		.bottom-bar {
			position: fixed;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 999;
			height: 70px;
			background: #ffffff;
			border-top: 1px solid #e4e7ed;
			padding: 10px 14px;
			box-sizing: border-box;
			
			.home-entry {
				flex: none;
				flex-direction: column;
				width: 36px;
				height: 50px;
				margin-right:14px;
				cursor: pointer;
				font-size: 26px;
				color: #666;
				
				.home-text{
					font-size: 12px;
					color: #666;
				}
			}
			
			.shop-btn {
				flex: 1;
				height:44px;
				line-height:44px;
				text-align: center;
				color: #ffffff;
				background: #b8860b;
				border-radius: 8px;
				font-size: 15px;
				cursor: pointer;
			}
		}
		
		.report-panel {
			height: 100%;
			padding: 20px 14px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			
			.report-header {
				flex: none;
				padding: 0 14px 14px;
				border-bottom: 1px solid #e4e7ed;
				
				.report-title {
					color: #222222;
					font-size: 15px;
					font-weight: bold;
				}
				
				.report-close {
					font-size: 20px;
					color: #999999;
					cursor: pointer;
				}
			}
			
			.report-list {
				flex: 1;
				min-height: 0;
				overflow-y: auto;
				
				.report-empty {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					padding: 30px 0;
					color: #888888;
					
					.empty-icon {
						font-size: 40px;
						color: #999;
						margin-bottom: 14px;
					}
					
					.empty-text {
						font-size: 13px;
						line-height:1.5;
						text-align: center;
					}
				}
				
				.report-item {
					padding: 14px 12px;
					border-bottom: 1px solid #e4e7ed;
					
					&:last-child{
						border-bottom:none;
					}
					
					.report-item-link {
						word-break: break-all;
						color: #333;
						font-weight: bold;
						font-size:13px;
					}
					.report-item-remark{
						margin-top:8px;
						word-break: break-all;
						color: #999;
						font-size:12px;
					}
					
					.report-item-content {
						margin-top:8px;
						width:100%;
						color: #555555;
						font-size: 12px;
						
						.item-row {
							flex:1;
							gap:14px;
							
							.price-value {
								color: #39b54a;
							}
						}
						
						.item-actions{
							flex: none;
							width:55px;
							
							.edit-row {
								font-size: 20px;
								color: #666666;
								cursor: pointer;
							}
							
							.delete-row {
								font-size: 20px;
								color: #e33737;
								cursor: pointer;
							}
						}
					}
					
				}
				
			}
			
			.report-import-row {
				flex: none;
				padding: 14px 0;
				border-top: 1px solid #e4e7ed;
				width: 100%;
				
				.import-item {
					flex: 1;
					flex-direction: column;
					
					.import-icon {
						font-size: 26px;
						color: #333;
					}
					
					.import-text {
						font-size: 12px;
						color: #333;
						margin-top: 8px;
					}
				}
			}
			
			.report-confirm {
				flex: none;
				width: 100%;
				height: 44px;
				line-height: 44px;
				text-align: center;
				color: #ffffff;
				background: #c4a35a;
				border-radius: 8px;
				font-size: 15px;
				cursor: pointer;
			}
		}
		
		.add-panel {
			
			.add-header{
				flex: none;
				padding:14px;
				border-bottom: 1px solid #e4e7ed;
				
				.add-title{
					color: #222222;
					font-size: 15px;
					font-weight: bold;
				}
				
				.add-close{
					font-size: 20px;
					color: #999999;
					cursor: pointer;
				}
			}
			
			.add-body{
				padding:0 14px 14px;
				
				.add-field {
					padding-top:14px;
					
					.add-label {
						margin-bottom: 8px;
						color: #333;
						font-size:14px;
					}
					
					.add-input,
					.add-textarea {
						width: 100%;
						padding:12px;
						color: #222222;
						background: #f6f6f6;
						border-radius: 4px;
						font-size: 14px;
						box-sizing: border-box;
					}
					
					.add-input {
						height:44px;
						line-height: 20px;
					}
					
					.add-textarea {
						word-break: break-all;
					}
				}
			}
			
			.add-actions {
				padding: 14px;
				border-top: 1px solid #e4e7ed;
				
				.add-submit {
					width:100%;
					text-align: center;
					height: 40px;
					line-height: 40px;
					border-radius: 20px;
					font-size: 15px;
					cursor: pointer;
					color: #ffffff;
					background: #e33737;
				}
			}
		}
	}
</style>